import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoutes = () => {
    const token = localStorage.getItem("access_token");
    const location = useLocation();
    const isAuth = token;
    return isAuth ? <Outlet /> : <Navigate to="/" replace state={{ from: location }} />;
};

export default ProtectedRoutes;